export const isValidFormData = <T = unknown>(data: Record<keyof T, any>, formFieldsValidator: Record<
  keyof T,
  Record<'isValid', (value: any) => boolean>
>) => Object.keys(data).every((key) => formFieldsValidator[key].isValid(data[key]))